const languages = require('./languages')
const defaultLanguage = require('./defaultLanguage')

// Coarse page group of a path: a Plausible prop for Trial CTA Click, and a column of the content inventory.
// Identical in www/ and blog/ (www/test/page-group.test.js checks). The app classifies signups itself.
const COVERAGE = ['coverage', 'abdeckung', 'cobertura', 'couverture', 'copertura', 'daekning']
const COMPARE = ['compare', 'vergleich', 'comparativa', 'comparaison', 'confronto', 'comparacao', 'sammenligning']
const FEATURES = ['power-dialer', 'lead-tracking', 'lead-prioritization', 'lead-recycling', 'lead-distribution', 'email', 'sms', 'integrations', 'telemarketing-software', 'sales-teams']
const GROUPS = { pricing: 'pricing', 'case-studies': 'case-study', 'book-a-demo': 'demo', docs: 'docs', privacy: 'legal', terms: 'legal', dpa: 'legal', about: 'company' }

const pageGroup = (pathname) => {
  const segments = (pathname || '/').toLowerCase().split('/').filter(Boolean)
  if (segments[0] === 'blog') return 'blog'
  if (segments[0] !== defaultLanguage && languages.includes(segments[0])) segments.shift()
  const [first] = segments
  if (!first) return 'home'
  if (COMPARE.includes(first)) return 'comparison'
  if (GROUPS[first]) return GROUPS[first]
  if (COVERAGE.includes(first)) return 'coverage'
  if (FEATURES.includes(first)) return 'feature'
  return 'other'
}

module.exports = pageGroup
